import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { createMetricsQueryClient } from '@/infrastructure/query/queryClient';

export function MetricsQueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(() => createMetricsQueryClient());
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
